/**
 * BILA AJAX NEWSLETTER
 */
jQuery(document).ready(function ($) {
  $("#newsletter-custom-form").on("submit", function (e) {
    e.preventDefault();

    var $form = $(this);
    var $email = $form.find('input[name="ne"]');
    var $button = $form.find(".theme-submit");
    var $notification = $form.find(".notification");
    var email = $email.val();

    // Basic validation
    if (!email || email.indexOf("@") === -1) {
      showNotification("Please enter a valid email", "error");
      return;
    }

    // Show loading
    $button.prop("disabled", true);
    var originalHtml = $button.html();
    // change text for "Subscribing..." for english, and "اشتراك..." for arabic
    if (document.documentElement.lang === "ar") {
      $button.html("<span>اشتراك...</span>");
    } else {
      $button.html("<span>Subscribing...</span>");
    }
    // $button.html("<span>Subscribing...</span>");

    // Hide previous notifications
    $notification
      .attr("aria-hidden", "true")
      .removeClass("error success")
      .text("");

    // Prepare data
    var formData = new FormData($form[0]);
    formData.append("action", "newsletter_custom_subscribe");
    formData.append("nonce", newsletter_ajax.nonce);

    // Send AJAX
    $.ajax({
      url: newsletter_ajax.url,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      dataType: "json",
      success: function (response) {
        if (response.success) {
          showNotification(response.data.message, response.data.type);
          $email.val(""); // Clear field

          // Optional: Hide form after success
          // setTimeout(function() {
          //     $form.fadeOut(300, function() {
          //         $form.replaceWith('<div class="success-message">Thank you for subscribing!</div>');
          //     });
          // }, 2000);
        } else {
          showNotification(response.data.message, response.data.type);
        }
      },
      error: function (xhr, status, error) {
        // console.log("AJAX Error:", error, xhr.responseText);
        showNotification("Network error. Please try again.", "error");
      },
      complete: function () {
        $button.prop("disabled", false).html(originalHtml);
      },
    });

    function showNotification(message, type) {
      $notification
        .attr("aria-hidden", "false")
        .removeClass("error success warning")
        .addClass(type)
        .text(message)
        .fadeIn();

      // Auto-hide after 5 seconds
      setTimeout(function () {
        $notification.fadeOut(300, function () {
          $(this).attr("aria-hidden", "true");
        });
      }, 5000);
    }
  });
});
